import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import SubmissionStageIcon from '../../assets/customIcons/submissionStageIcon';
import ReviewFormIcon from '../../assets/customIcons/reviewForm';
import ReviewStageIcon from '../../assets/customIcons/reviewStageIcon';
import AppFormIcon from '../../assets/customIcons/appFormIcon';
import PersonLockIcon from '../../assets/customIcons/personLockIcon';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { GRID_REORDER_COL_DEF } from '@mui/x-data-grid-premium';
import IconButton from '@mui/material/IconButton';
import { getEntityPrefix } from '../../utils/utilFunctions';
import BasicCellText from './BasicCellText';

const StageColumns = (columnWidths, isAppProcess) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [openTooltip, setOpenTooltip] = useState(0);

	return [
		{
			field: 'order',
			headerName: '#',
			headerAlign: 'center',
			align: 'center',
			renderCell: (cellValues) => cellValues?.row?.id,
			width: 70,
			resizable: false
		},
		{
			field: 'form_type',
			headerName: 'Type',
			description: 'Type',
			renderCell: (cellValues) => {
				const title = cellValues?.formattedValue?.toLowerCase();
				const currentCell = {
					...cellValues,
					formattedValue: title?.includes('application')
						? 'Application Form'
						: title?.includes('review form')
						? 'Review Form'
						: cellValues?.formattedValue
				};

				return (
					<BasicCellText
						cellValues={currentCell}
						StartIcon={
							title?.includes('application')
								? AppFormIcon
								: title?.includes('review form')
								? ReviewFormIcon
								: title?.includes('submission stage')
								? SubmissionStageIcon
								: ReviewStageIcon
						}
					/>
				);
			},
			flex: !columnWidths.title && 1
		},
		{
			field: 'label',
			headerName: 'Name',
			description: 'Name',
			renderCell: (cellValues) => (
				<BasicCellText
					cellValues={cellValues}
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
				/>
			),
			flex: !columnWidths.title && 1
		},
		{
			field: 'unique_identifier',
			headerName: 'Entity ID',
			description: 'Entity ID',
			renderCell: (cellValues) => {
				const FormPrefix = getEntityPrefix({
					type:
						cellValues?.row?.form_type === 'application' ? 'application-form' : 'application-form',
					isMaters: true
				});
				cellValues.formattedValue = isAppProcess
					? cellValues?.row?.uniqueIdentifier
					: `${FormPrefix}${cellValues.formattedValue}`;

				return (
					<BasicCellText
						cellValues={cellValues}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
					/>
				);
			},
			flex: !columnWidths.appId && 1
		},
		{
			field: 'startDate',
			headerName: 'Start',
			description: 'Start',
			renderCell: (cellValues) => {
				return cellValues?.formattedValue ? (
					<BasicCellText
						cellValues={cellValues}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
						isDate
					/>
				) : (
					'n/a'
				);
			},
			flex: !columnWidths.startDate && 1
		},
		{
			field: 'endDate',
			headerName: 'End',
			description: 'End',
			renderCell: (cellValues) => {
				return cellValues?.formattedValue ? (
					<BasicCellText
						cellValues={cellValues}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
						isDate
					/>
				) : (
					'n/a'
				);
			},
			flex: !columnWidths.endDate && 1
		},
		{
			field: 'action',
			headerName: 'Usage & Actions',
			description: 'Usage & Actions',
			renderCell: (cellValues) => {
				const in_use = cellValues?.row?.in_use;
				const isDisabled = in_use || cellValues?.row?.hasSubsequentSubmissionStage;

				return (
					<div
						style={{
							display: 'flex',
							gap: '5px',
							alignItems: 'center'
						}}
					>
						{in_use && <PersonLockIcon isActive={true} />}
						<IconButton
							aria-label="delete"
							disabled={isDisabled}
							onClick={() => {
								searchParams.set('deleteModal', cellValues?.row?.form_id);
								searchParams.set('type', 'form');
								setSearchParams(searchParams);
							}}
						>
							<DeleteForeverIcon color={isDisabled ? 'action' : 'error'} />
						</IconButton>
					</div>
				);
			},
			disableColumnMenu: true,
			disableReorder: true,
			sortable: false,
			resizable: false,
			width: 130,
			headerAlign: 'right',
			align: 'right'
		},
		{
			...GRID_REORDER_COL_DEF,
			width: 40
		}
	];
};

export default StageColumns;
